import { Component, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { APP_BASE_HREF, Location } from '@angular/common';
import { AppBase } from '@common/app/app.component.base';
import { GoogleAnalyticsService } from '@common/services/google-analytics.service';
import { Title } from '@angular/platform-browser';
import { CommunityService } from '@common/services/community.service';
import { ContentService } from '@common/services/content.service';
import { SeoService } from '@common/services/seo.service';
import { KenalyticsService } from '@common/services/kenalytics.service';
import { ThemeService } from '@common/services/theme.service';
import { AnalyticsService } from '@common/analytics/services/analytics.service';
import { WINDOW } from '@common/services/window.service';
import { AnalyticsClickService } from '@common/analytics/services/click.service';
import { SvgIconWrapperService } from './services/svg-icon-wrapper.service';
import { InMemoryQueryService } from '@common/services/inmemory.query.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends AppBase {
    public cmsService: ContentService;

    protected get useTitleFromIndexPage(): boolean {
        return !!this.titleService.getTitle();
    }
    protected get useGenericCommunityServiceErrorHandling(): boolean {
        return false;
    }

    constructor(
        router: Router,
        location: Location,
        analytics: GoogleAnalyticsService,
        titleService: Title,
        communityService: CommunityService,
        route: ActivatedRoute,
        contentService: ContentService,
        seoService: SeoService,
        kenalyticsService: KenalyticsService,
        themeService: ThemeService,
        analyticsService: AnalyticsService,
        @Inject(WINDOW) window: Window,
        @Inject(APP_BASE_HREF) baseHref: string,
        clickService: AnalyticsClickService,
        private queryService: InMemoryQueryService,
        private svgIconWrapperService: SvgIconWrapperService,
    ) {
        super(
            router,
            location,
            analytics,
            titleService,
            communityService,
            route,
            contentService,
            seoService,
            kenalyticsService,
            analyticsService,
            window,
            baseHref,
            clickService,
        );
        svgIconWrapperService.load();

        this.cmsService = contentService;
        seoService.appendCommunityToTitle = false;

        communityService.community$.subscribe((community) => {
            if (community) {
                themeService.loadStyle(`${community.code}.css`);
            }
        });
    }

    override onNavigationEnd(ev: NavigationEnd): void {
        if (ev.url.includes('register')) {
            this.queryService.publish('app-menu', 'showMenuLinks', false);
        } else {
            this.queryService.publish('app-menu', 'showMenuLinks', true);
        }
    }

    override shouldSendPageView(baseUrl: string): boolean {
        const urlArray = baseUrl.split('/').filter((x) => !!x);
        if (!urlArray || urlArray.length < 2) return true;

        const isCommand = urlArray[1] === 'do';
        const willRedirect =
            urlArray.length === 2 && urlArray[1] === 'register';

        return !isCommand && !willRedirect;
    }
}
